import { render } from "./ClientsMonthly.vue?vue&type=template&id=0b4b921c&scoped=true"
import script from "./ClientsMonthly.vue?vue&type=script&lang=js"
export * from "./ClientsMonthly.vue?vue&type=script&lang=js"

import "./ClientsMonthly.vue?vue&type=style&index=0&id=0b4b921c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4b921c"]])

export default __exports__